import { slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray, extends as _extends, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { v4 } from 'uuid';
import { AgGridReact } from 'ag-grid-react';
import IlDataTableV3Toolbar from './IlDataTableV3Toolbar.js';
import IlDataTableV3Search from './IlDataTableV3Search.js';
import IlDataTableV3Pagination from './IlDataTableV3Pagination.js';
import IlDataTableV3ContextMenu from './IlDataTableV3ContextMenu.js';
import { IlIconInitializer } from '../IlIconInitializer/index.js';
import { IlLoading } from '../IlLoading/index.js';
import { IlSkeletonText } from '../IlSkeletons/IlSkeletonText/index.js';
import 'carbon-components-react';
import { IlDataTableV3ColumnManager } from './IlDataTableV3ColumnManager.js';
import { IlIcon } from '../IlIcon/index.js';
import { DTV3_PAGINATION_DEFAULT_PAGE_SIZES } from '../../shared/constants/generalConstants.js';
import ReactDOMServer from 'react-dom/server';
import IlDataTableV3Expanding from './ExpandingTable.js';
import IlDataTableV3Checkbox from './IlDataTableV3Checkbox.js';
import { IlDataTableV3CellRenderer } from './IlDataTableV3CellRenderer.js';
import AgGridNavigationAdapter from './IlDataTableV3NavigationAdapter.js';
import { useStickyHeader } from './useStickyHeader.js';
import { IlButton } from '../IlButton/index.js';
import { IlBackToTopButton } from '../IlBackToTopButton/index.js';
import classNames from 'classnames';

function IlDataTableV3(props) {
  var firstLoadRef = useRef(true);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    columnManagerVisible = _useState2[0],
    setColumnManagerVisible = _useState2[1];
  var columnSettings = useRef(loadColumnSettings());
  var _useState3 = useState(props.data && props.data.length || null),
    _useState4 = _slicedToArray(_useState3, 2),
    totalCount = _useState4[0],
    setTotalCount = _useState4[1];
  var _useState5 = useState(props.data || null),
    _useState6 = _slicedToArray(_useState5, 2),
    data = _useState6[0],
    setData = _useState6[1];
  var searchRef = useRef('');
  var suspendLoadMoreDataAppend = useRef(false);
  var toolBarRef = useRef();
  var lastSearchRef = useRef(null);
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    filteredRowsCount = _useState8[0],
    setFilteredRowsCount = _useState8[1];
  var lastSearchTimeRef = useRef(null);
  var _useState9 = useState(!!props.fetchData),
    _useState10 = _slicedToArray(_useState9, 2),
    loading = _useState10[0],
    setLoading = _useState10[1];
  var _useState11 = useState(loading),
    _useState12 = _slicedToArray(_useState11, 2),
    loadMoreLoading = _useState12[0],
    setLoadMoreLoading = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    selectedRows = _useState14[0],
    setSelectedRows = _useState14[1];
  var currentlySelectingAll = useRef(false);
  var _useState15 = useState(1),
    _useState16 = _slicedToArray(_useState15, 2),
    contextMenuX = _useState16[0],
    setContextMenuX = _useState16[1];
  var _useState17 = useState(1),
    _useState18 = _slicedToArray(_useState17, 2),
    contextMenuY = _useState18[0],
    setContextMenuY = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    contextMenuVisible = _useState20[0],
    setContextMenuVisible = _useState20[1];
  var _useState21 = useState([]),
    _useState22 = _slicedToArray(_useState21, 2),
    contextMenuItems = _useState22[0],
    setContextMenuItems = _useState22[1];
  var _useState23 = useState(null),
    _useState24 = _slicedToArray(_useState23, 2),
    contextMenuData = _useState24[0],
    setContextMenuData = _useState24[1];
  var _useState25 = useState(props.page || 0),
    _useState26 = _slicedToArray(_useState25, 2),
    page = _useState26[0],
    setPage = _useState26[1];
  var _useState27 = useState(props.pageSize),
    _useState28 = _slicedToArray(_useState27, 2),
    pageSize = _useState28[0],
    setPageSize = _useState28[1];
  var _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    isDragging = _useState30[0],
    setIsDragging = _useState30[1];
  var isDraggingData = useRef(null);
  var prevSearchRef = useRef(null);
  var prevPageRef = useRef(null);
  var prevPageSizeRef = useRef(null);
  var sortChangedRef = useRef(null);
  var gridDivRef = useRef(null);
  var loadingDataGeneratedRef = useRef(null);
  var navigationAdapterRef = useRef(null);
  function deselectAll() {
    var _gridApi$current;
    currentlySelectingAll.current = true;
    setSelectedRows([]);
    if ((_gridApi$current = gridApi.current) !== null && _gridApi$current !== void 0 && _gridApi$current.deselectAll) {
      var _gridApi$current2;
      (_gridApi$current2 = gridApi.current) === null || _gridApi$current2 === void 0 || _gridApi$current2.deselectAll();
    }
    props.onRowDeselectAll();
    setTimeout(function () {
      currentlySelectingAll.current = false;
    }, 250);
  }
  useEffect(function () {
    if (page > Math.ceil(totalCount / pageSize) - 1) {
      var newPage = Math.ceil(totalCount / pageSize - 1);
      if (newPage >= 0) {
        setPage(newPage);
        if (props.fetchData) {
          // Danny made me do it! (thanks for the new syntax!)
          setData(new Array(pageSize).fill({}));
          setLoading(true);

          // FIXME: This is a dumb race condition work-around.
          setTimeout(function () {
            fetchData(true);
          }, 1);
        }
      }
    }
  }, [totalCount]);
  useEffect(function () {
    deselectAll();
  }, [page]);
  useStickyHeader(props.stickyHeader, '.ag-header', function () {}, function () {}, props.stickyHeaderOffset, props.stickyHeaderZIndex);

  //////////////////////////////////////////////////////////////////////////////
  // fetchData

  var LAST_FETCH_DATA_CALL = useRef(null);
  function fetchData() {
    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (!force) {
      if (LAST_FETCH_DATA_CALL.current && new Date().getTime() - LAST_FETCH_DATA_CALL.current < 1000) {
        return;
      }
    }
    LAST_FETCH_DATA_CALL.current = new Date().getTime();
    var savedSelectedRows = selectedRows.map(function (d) {
      return d;
    });
    deselectAll();
    if (props.fetchData) {
      var _gridApi$current3;
      var sortModel = [];
      if ((_gridApi$current3 = gridApi.current) !== null && _gridApi$current3 !== void 0 && _gridApi$current3.sortController) {
        sortModel = gridApi.current.sortController.getSortModel();
      }
      setLoading(true);
      if (!props.paginationLoadMore) {
        setData(generateLoadingData());
      } else {
        // TODO: !data.length is not a robust way to check for first load
        // First load always displays skeletons
        // if (!data.length) {
        /* Condition: When paginationLoadMoreForceSkeleton is true or during initial load state add 10 loading rows */
        var loadingDataGenerated = false;
        if (props.paginationLoadMoreForceSkeleton || firstLoadRef.current) {
          setData(generateLoadingData(pageSizeRef.current * (pageRef.current + 1)));
          loadingDataGenerated = true;
        }

        /* Condition: paginationLoadMoreForceSkeleton shows skeleton state for all rows which has data:
        When paginationLoadMoreForceSkeleton is false and during sort make rows into loading state without any additional rows
        Or When paginationLoadMoreForceSkeleton is false and force fetch is called with resetting pagination is called show loading
        rows with page size */
        if (!props.paginationLoadMoreForceSkeleton && pageRef.current === prevPageRef.current || !props.paginationLoadMoreForceSkeleton && pageRef.current <= prevPageRef.current) {
          setData(generateLoadingData(pageSizeRef.current * pageRef.current));
          loadingDataGenerated = true;
        }
        loadingDataGeneratedRef.current = loadingDataGenerated;
        // }
      }
      setSelectedRows(savedSelectedRows);
      var dataClone = data.map(function (d) {
        return d;
      });

      // Deal with load more pagination logic
      var appendData = false;
      if (props.paginationLoadMore) {
        appendData = true;
      }
      if (props.paginationLoadMoreDoNotAppendData) {
        appendData = false;
      }
      var _page = pageRef.current;
      var _pageSize = pageSizeRef.current;

      // This only matters if we're in load more mode
      if (props.paginationLoadMore) {
        if (prevSearchRef.current !== searchRef.current) {
          if (props.clientSideSearch && !firstLoadRef.current) {
            setLoading(false);
            return;
          }
          appendData = false;
        }
        // If the page number is going backwards, that's weird.
        else if (pageRef.current < prevPageRef.current) {
          appendData = false;
        }
        // If the page is the same but we're fetching data, I guess that means
        // we're sorting or we did a forceFetch data.
        else if (pageRef.current === prevPageRef.current) {
          appendData = false;
          _pageSize = _pageSize * (_page + 1);
          _page = 0;
        }
      }
      if (appendData || props.paginationLoadMoreDoNotAppendData) {
        setLoadMoreLoading(true);
      }
      props.fetchData(function (data) {
        if (appendData) {
          setData([].concat(_toConsumableArray(dataClone), _toConsumableArray(data)));
        } else {
          setData(data);
        }
        setLoading(false);
        setLoadMoreLoading(false);

        // Set some refs to keep track of previous values as well as the
        // firstLoad state.
        firstLoadRef.current = false;
        prevSearchRef.current = searchRef.current;
        prevPageRef.current = pageRef.current;
        prevPageSizeRef.current = pageSizeRef.current;
        sortChangedRef.current = false;
        if (props.paginationLoadMore) {
          setSelectedRows(savedSelectedRows);
        }
      }, setTotalCount, {
        page: _page,
        pageSize: _pageSize,
        sortModel: sortModel,
        search: searchRef.current,
        prevSearch: prevSearchRef.current,
        prevPage: prevPageRef.current,
        prevPageSize: prevPageSizeRef.current
      });
    }
  }
  useEffect(function () {
    navigationAdapterRef.current = new AgGridNavigationAdapter();

    // Destructor
    return function () {
      navigationAdapterRef.current.destructor();
    };
  }, []);
  useEffect(function () {
    setData(props.data);
    if (props.data && props.data.length > 0) {
      setTotalCount(props.data.length);
    }
  }, [props.data]);

  //Clicking outside of the icon closes the overflow menu
  useEffect(function () {
    function handleOnClickOutside(event) {
      if (toolBarRef.current && !toolBarRef.current.contains(event.target)) {
        setColumnManagerVisible(false);
      }
    }
    document.addEventListener('mousedown', handleOnClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleOnClickOutside);
    };
  }, []);
  var gridApi = useRef();
  // Because we potentially mutate the columns based on other properties,
  // cloning columns per-render is too slow.  So we're moving it into a state
  // that's mutated via useEffect.
  var _useState31 = useState([]),
    _useState32 = _slicedToArray(_useState31, 2),
    columnsState = _useState32[0],
    setColumnsState = _useState32[1];

  // This is here for the sake of forceFetchData.  Without a ref, fetchData
  // when called via forceFetchData will use the initial value.  This is a fix,
  // but if you're reading this, and you know a better one feel free to reach
  // out and/or push a PR.
  var pageSizeRef = useRef(pageSize);
  var pageRef = useRef(page);
  useEffect(function () {
    pageSizeRef.current = pageSize;
    pageRef.current = page;
    deselectAll();
  }, [pageSize, page]);

  //callback function when there is a column state change getColumnSettings will be called.
  useEffect(function () {
    props.getColumnsSettings(columnSettings.current);
  }, [columnsState]);
  useEffect(function () {
    if (!columnManagerVisible) {
      props.onColumnManagerClose(columnSettings.current);
    }
  }, [columnManagerVisible]);
  var defaultColDef = {
    sortable: !!props.sortable,
    resizable: !!props.resizable,
    lockPinned: true,
    suppressSizeToFit: true
  };

  // If we're using serverside data fetching, we want to effectively disable
  // client-side sorting without overriding the controls.
  if (props.fetchData) {
    defaultColDef.comparator = function () {
      return 0;
    };
  }
  useEffect(function () {
    if (props.persistColumnSettingsInLocalStorage && !props.id) {
      // Typing it weird to bypass sonarqube. Because seriously...
      window['console'].warn('You must supply unique prop `id` to IlDataTableV3 in order to use `persistColumnSettingsInLocalStorage=true`');
    }
  }, []);
  useEffect(function () {
    if (gridApi && gridApi.current) {
      var nodeMap = {};
      if (gridApi.current.rowModel !== undefined && gridApi.current.rowModel.nodeManager !== undefined) {
        Object.values(gridApi.current.rowModel.nodeManager.allNodesMap).forEach(function (node) {
          nodeMap[node.data.id] = node;
          // gridApi.current.selectNode(node);
        });
      }
      selectedRows.forEach(function (selectedNode) {
        if (nodeMap[selectedNode.id]) {
          gridApi.current.selectNode(nodeMap[selectedNode.id], true);
        }
      });
    }
  }, [selectedRows]);

  //////////////////////////////////////////////////////////////////////////////
  // genereateLoadingData

  function generateLoadingData(size) {
    var loadingData = [];
    var _loop = function _loop(i) {
      var singleData = {};
      props.columns.forEach(function (column) {
        var _data$i;
        column.field;
        singleData[column.field] = '';

        // Setting the ID if we have it to help maintain selected rows
        if ((_data$i = data[i]) !== null && _data$i !== void 0 && _data$i.id) {
          var _data$i2;
          singleData.id = (_data$i2 = data[i]) === null || _data$i2 === void 0 ? void 0 : _data$i2.id;
        } else {
          singleData.id = v4();
        }
      });
      loadingData.push(singleData);
    };
    for (var i = 0; i < (size || pageSizeRef.current); i++) {
      _loop(i);
    }
    return loadingData;
  }
  useEffect(function () {
    setFilteredRowsCount(data.length);
  }, [data]);

  //////////////////////////////////////////////////////////////////////////////
  // Column Settings Stuff

  function loadColumnSettings() {
    // If you haven't provided both and ID and aren't storing the settings in
    // local storage we can't really do anything, and it's up to the developer
    // to provide columnSettings via a prop
    if (!props.id || !props.persistColumnSettingsInLocalStorage) {
      return props.columnSettings;
    }
    var settings = localStorage.getItem("il-dt-v3-".concat(props.id));
    if (settings) {
      try {
        return JSON.parse(settings);
      } catch (e) {
        return props.columnSettings;
      }
    } else {
      return props.columnSettings;
    }
  }
  function persistColumnSettings(columns, forceGivenOrder) {
    var columnsSettingsByField = {};
    var localColumnSettingsByField = {};
    columnSettings.current.forEach(function (columnSetting) {
      columnsSettingsByField[columnSetting.field] = columnSetting;
    });
    if (columns) {
      columns.forEach(function (column) {
        localColumnSettingsByField[column.field] = column;
      });
    }
    var finalColumnSettings = [];
    gridApi.current.getColumnDefs().forEach(function (column) {
      if (column.colId === 0) {
        return;
      }
      var finalColumnSetting = {
        field: column.field,
        width: column.width,
        pinned: column.pinned,
        hide: column.hide
      };
      if (columnsSettingsByField[column.field]) {
        finalColumnSetting = Object.assign(finalColumnSetting, columnsSettingsByField[column.field]);
      }
      if (localColumnSettingsByField[column.field]) {
        finalColumnSetting = Object.assign(finalColumnSetting, localColumnSettingsByField[column.field]);
      }
      finalColumnSettings.push(finalColumnSetting);
      columnsSettingsByField[finalColumnSetting.field] = finalColumnSetting;
    });
    if (forceGivenOrder) {
      finalColumnSettings = [];
      columns.forEach(function (column) {
        if (columnsSettingsByField[column.field]) {
          finalColumnSettings.push(columnsSettingsByField[column.field]);
        }
      });
    }
    if (props.id && props.persistColumnSettingsInLocalStorage) {
      localStorage.setItem("il-dt-v3-".concat(props.id), JSON.stringify(finalColumnSettings));
    }
    columnSettings.current = finalColumnSettings;
    setColumnsState(finalColumnSettings);
  }

  // Listen to changes on pageSize and page
  useEffect(function () {
    fetchData();
    if (gridApi.current) {
      gridApi.current.paginationGoToPage(page);
      gridApi.current.paginationSetPageSize(pageSize);
    }
  }, [pageSize, page]);

  // // Once data changes, loading should be false.
  // useEffect(() => {
  //   setLoading(false);
  // }, [data]);

  //////////////////////////////////////////////////////////////////////////////
  // Column Def/State/Settings

  function getColumnDefs() {
    var columns = props.columns;
    columnSettings.current = loadColumnSettings();

    // Just creating a map for easy access
    var columnsByField = {};
    columns.forEach(function (column) {
      columnsByField[column.field] = column;
    });

    // Just creating a map for easy access
    var columnSettingsByField = {};
    columnSettings.current.forEach(function (columnSetting) {
      delete columnSetting.showRowDragger;
      columnSettingsByField[columnSetting.field] = columnSetting;
    });
    var orderedColumns = [];

    // Append columns from columnSettings first.
    columnSettings.current.forEach(function (columnSetting) {
      if (columnsByField[columnSetting.field]) {
        orderedColumns.push(Object.assign({}, columnsByField[columnSetting.field], columnSetting));
      }
    });

    // Then append any that are present but don't exist in column settings.
    columns.forEach(function (column) {
      if (!columnSettingsByField[column.field]) {
        orderedColumns.push(column);
      }
    });
    var hasPinned = false;
    orderedColumns.forEach(function (column) {
      if (column.pinned) {
        hasPinned = true;
      }
    });
    var newColumns = [];
    if (props.selectable) {
      var selectColumn = {
        field: null,
        // headerCheckboxSelection: true,
        checkboxSelection: true,
        width: props.rowLevelDragHandle ? 74 : 64,
        minWidth: 64,
        lockPosition: 'left',
        sortable: false,
        cellClass: 'IlDataTableV3CheckboxCell',
        showDisabledCheckboxes: true,
        rowDrag: props.rowLevelDragHandle,
        headerComponent: function headerComponent() {
          return /*#__PURE__*/React__default.createElement("div", {
            className: classNames('IlDataTableV3--header-checkbox', _defineProperty({}, 'IlDataTableV3--header-checkbox-with-drag-handle', props.rowLevelDragHandle))
          }, /*#__PURE__*/React__default.createElement(IlDataTableV3Checkbox, {
            checked: selectedRows.length === props.pageSize || selectedRows.length === data.length,
            onChange: function onChange(ev) {
              if (!ev.target.checked) {
                deselectAll();
              } else {
                rowSelectionCallback(true);
              }
            }
          }));
        }
      };
      if (hasPinned) {
        selectColumn.pinned = 'left';
      }
      newColumns.push(selectColumn);
    }
    orderedColumns.forEach(function (column, i) {
      if (!column.hide) ;
    });
    orderedColumns.forEach(function (column, i) {
      var clone = JSON.parse(JSON.stringify(column));
      clone.cellRenderer = column.cellRenderer;
      clone.headerComponent = column.headerComponent;
      clone.suppressHeaderKeyboardEvent = column.suppressHeaderKeyboardEvent;
      clone.rowDraggerRenderer = column.rowDraggerRenderer;
      newColumns.push(clone);
    });
    newColumns.forEach(function (column, i) {
      // For the life of me, I don't remember what this is for.  Should probably
      // revisit this...
      var prevCellRenderer = column.cellRenderer;
      newColumns[i].cellRenderer = function (params) {
        if ((!data.length || !props.paginationLoadMore) && loading) {
          return /*#__PURE__*/React__default.createElement("div", {
            className: 'IlDataTableV3-Skeleton'
          }, /*#__PURE__*/React__default.createElement(IlSkeletonText, {
            width: '100%'
          }));
        }
        return /*#__PURE__*/React__default.createElement("div", {
          className: 'IlDataTableV3ContextMenuWrapper',
          onContextMenu: function onContextMenu(ev) {
            if (ev.target.tagName.toUpperCase() === 'DIV') {
              ev.preventDefault();
              setContextMenuX(ev.clientX);
              setContextMenuY(ev.clientY);
              setContextMenuVisible(true);
              setContextMenuItems(column.contextMenuItems || props.contextMenuItems);
              setContextMenuData(params);
            }
          }
        }, /*#__PURE__*/React__default.createElement("div", null, prevCellRenderer ? prevCellRenderer(params) : params.value));
      };
      var loadingState = loading;
      if (props.paginationLoadMore && !loadingDataGeneratedRef.current) {
        if (!props.paginationLoadMoreForceSkeleton) {
          loadingState = false;
        }
      }
      newColumns[i].cellRendererParams = {
        contextMenuItems: props.contextMenuItems,
        loading: loadingState,
        prevCellRenderer: prevCellRenderer,
        showRowDragger: column.showRowDragger,
        rowDraggerRenderer: column.rowDraggerRenderer
      };
      newColumns[i].cellRenderer = IlDataTableV3CellRenderer;
    });
    return newColumns;
  }
  function _renderBatchToolbar() {
    if (!props.batchActionsToolbarItems.length) {
      return null;
    } else {
      return /*#__PURE__*/React__default.createElement(IlDataTableV3Toolbar, {
        gridApi: gridApi.current,
        visibleItems: props.batchActionsToolbarVisibleItems,
        items: props.batchActionsToolbarItems,
        cancelButtonText: props.cancelButtonText,
        setSingleItemSelectedTranslation: props.setSingleItemSelectedTranslation,
        setMultipleItemsSelectedTranslation: props.setMultipleItemsSelectedTranslation,
        selectedRows: gridApi.current && gridApi.current.getSelectedRows() || [],
        onClose: function onClose() {
          setSelectedRows([]);
          currentlySelectingAll.current = true;
          gridApi.current.deselectAll();
          if (props.onCancelToolbarItems) {
            props.onCancelToolbarItems();
          }
          setTimeout(function () {
            currentlySelectingAll.current = false;
          }, 250);
        }
      });
    }
  }
  function _renderHeader() {
    if (!props.searchable) {
      return null;
    }
    if (selectedRows.length) {
      if (!props.suppressHideSearchOnSelection) {
        return null;
      }
    }
    function _onSearch() {
      setPage(0);
      pageRef.current = 0;
      if (searchRef.current === lastSearchRef.current) {
        return;
      } else {
        lastSearchRef.current = searchRef.current;
      }
      props.onSearch(searchRef.current);
      if (!props.fetchData || props.clientSideSearch) {
        setLoading(true);
        gridApi.current.setQuickFilter(searchRef.current);
        var filteredRows = [];
        gridApi.current.forEachNodeAfterFilter(function (node) {
          filteredRows.push(node);
        });
        setFilteredRowsCount(filteredRows.length);
        setLoading(false);
      } else {
        suspendLoadMoreDataAppend.current = true;
        if (props.suppressAutoSearch) {
          fetchData();
        } else if (searchRef.current.length >= props.searchMinimumLength) {
          fetchData();
        } else if (searchRef.current === '') {
          fetchData();
        }
      }
    }
    return /*#__PURE__*/React__default.createElement(IlDataTableV3Search, {
      value: searchRef.current,
      onSearch: function onSearch(searchValue) {
        searchRef.current = searchValue;
        _onSearch();
      },
      onChange: function onChange(ev) {
        searchRef.current = ev.target.value;
        if (props.suppressAutoSearch) {
          return;
        }

        // Client-side autoSearch
        if (!props.fetchData) {
          _onSearch();
        }
        // Server-side autoSearch -- needs to be debounced
        else {
          lastSearchTimeRef.current = new Date();
          setTimeout(function () {
            // Check that lastSearchTime isn't null, because we set it back to
            // null to skip any lingering timeouts.
            if (lastSearchTimeRef.current !== null) {
              // If it's been long enough, we're good to go. Note we're
              // setting this as a bit less than the timeout to avoid race
              // conditions.
              if (new Date() - lastSearchTimeRef.current > props.searchDebounceTime - 100) {
                _onSearch();
                lastSearchTimeRef.current = null;
              }
            }
          }, props.searchDebounceTime);
        }
      },
      placeHolderText: props.searchPlaceholderText
    });
  }
  function _renderToolbar() {
    if (!props.toolbar && !props.columnManager) {
      return null;
    } else {
      var buttonClass = '';
      if (columnManagerVisible) {
        buttonClass = 'IlDataTableV3ColumnManagerButton';
      }
      return /*#__PURE__*/React__default.createElement("div", {
        className: "toolbar-container"
      }, props.columnManager ? /*#__PURE__*/React__default.createElement("div", {
        ref: toolBarRef,
        style: {
          position: 'relative',
          display: 'flex'
        }
      }, /*#__PURE__*/React__default.createElement(IlButton, {
        className: buttonClass,
        kind: "ghost",
        hasIconOnly: true,
        icon: 'gs-columns',
        iconDescription: "",
        onClick: function onClick() {
          return setColumnManagerVisible(!columnManagerVisible);
        }
      }), columnManagerVisible ? /*#__PURE__*/React__default.createElement(IlDataTableV3ColumnManager, {
        nonceId: props.columnManagerNonceId,
        onClose: function onClose() {
          return setColumnManagerVisible(false);
        },
        columns: getColumnDefs(),
        setColumns: function setColumns(columns) {
          persistColumnSettings(columns, true);
        }
      }) : null) : null, props.toolbar);
    }
  }
  function _renderSecondaryToolbarContent() {
    if (!props.secondaryToolbarContent) {
      return null;
    }
    return /*#__PURE__*/React__default.createElement("div", {
      className: "secondaryToolbar-container"
    }, props.secondaryToolbarContent);
  }
  function _renderTertiaryToolbar() {
    if (!props.tertiaryToolbar) {
      return null;
    } else {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "tertiaryToolbar-container"
      }, props.tertiaryToolbar);
    }
  }
  var getGridDivYPosition = function getGridDivYPosition() {
    if (gridDivRef.current) {
      var rect = gridDivRef.current.getBoundingClientRect();
      return rect.top + window.scrollY;
    }
    return 0;
  };
  function _renderPagination() {
    // No Pagination
    if (!props.pagination) {
      return null;
    }
    // Load More "Pagination"
    else if (props.paginationLoadMore) {
      if (data.length === totalCount) {
        return null;
      }
      if (searchRef.current && props.clientSideSearch) {
        return null;
      }
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, props.paginationLoadMoreScrollToTop && /*#__PURE__*/React__default.createElement("div", {
        className: 'IlDataTableV3-LoadMoreContainer'
      }, /*#__PURE__*/React__default.createElement(IlBackToTopButton, {
        scrollY: getGridDivYPosition()
      })), /*#__PURE__*/React__default.createElement("div", {
        className: ['IlDataTableV3-LoadMoreContainer', loading ? 'loading' : ''].join(' ')
      }, /*#__PURE__*/React__default.createElement("button", {
        className: 'IlDataTableV3-LoadMoreButton',
        onClick: function onClick() {
          var lastPage = Math.ceil(totalCount / pageSize) - 1;
          if (page + 1 > lastPage) {
            setPage(lastPage);
          } else {
            setPage(page + 1);
          }
        }
      }, loadMoreLoading && /*#__PURE__*/React__default.createElement(IlLoading, {
        small: true,
        withOverlay: false
      }), /*#__PURE__*/React__default.createElement("span", {
        className: loadMoreLoading ? 'IlDataTableV3-LoadMore-Text-Loading' : 'IlDataTableV3-LoadMore-Text-NotLoading'
      }, typeof props.paginationLoadMoreText === 'function' ? props.paginationLoadMoreText() : props.paginationLoadMoreText))));
    }
    // Regular Pagination
    else {
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(IlDataTableV3Pagination, {
        page: page + 1,
        pageSizes: props.pageSizes || DTV3_PAGINATION_DEFAULT_PAGE_SIZES,
        pageSize: pageSize,
        totalCount: totalCount,
        onChange: function onChange(ev) {
          props.onPaginationChange(ev);
          deselectAll();
        },
        onFirstPage: function onFirstPage(page) {
          setPage(0);
        },
        onNextPage: function onNextPage(page) {
          setPage(page + 1);
        },
        onGoToPage: function onGoToPage(page) {
          setPage(page);
        },
        onPreviousPage: function onPreviousPage(page) {
          setPage(page - 1);
        },
        onLastPage: function onLastPage(page) {
          setPage(Math.ceil(totalCount / pageSize) - 1);
        },
        onChangePageSize: function onChangePageSize(pageSize) {
          setPage(0);
          setPageSize(pageSize);
        },
        standardPaginatorStrings: props.standardPaginatorStrings
      }));
    }
  }
  function _renderTitle() {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, ' ', props.title ? /*#__PURE__*/React__default.createElement("h2", {
      className: "IlDataTableV3Title"
    }, props.title) : '', _renderSecondaryToolbarContent(), props.description ? /*#__PURE__*/React__default.createElement("p", {
      "class": "bx--data-table-header__description"
    }, props.description) : '');
  }
  if (!data) {
    return /*#__PURE__*/React__default.createElement(IlLoading, null);
  }
  function _renderNoRows() {
    if (filteredRowsCount === 0) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "IlDataTableV3NoRowsOverlay"
      }, props.overlayNoRows ? props.overlayNoRows : /*#__PURE__*/React__default.createElement("p", null, "No Rows"));
    }
  }
  function _onRowDragMove(event) {
    var movingNode = event.node;
    var overNode = event.overNode;
    var rowNeedsToMove = movingNode !== overNode;
    // since we have unmanaged row dragging, we might end up in a scenario
    // where on dragged row is an empty row and overIndex is set to -1
    // this problem will go away when we switch to IlGrid and managed row dragging

    if (rowNeedsToMove && overNode) {
      // the list of rows we have is data, not row nodes, so extract the data
      var movingData = movingNode.data;
      var overData = overNode.data;
      var fromIndex = data.indexOf(movingData);
      var toIndex = data.indexOf(overData);
      if (toIndex > -1) {
        var newStore = data.slice();
        moveInArray(newStore, fromIndex, toIndex);
        gridApi.current.setRowData(newStore);
        isDraggingData.current = newStore;
      }
    }
    function moveInArray(arr, fromIndex, toIndex) {
      var element = arr[fromIndex];
      arr.splice(fromIndex, 1);
      arr.splice(toIndex, 0, element);
    }
  }
  function _renderGrid() {
    var _navigationAdapterRef, _navigationAdapterRef2, _navigationAdapterRef3, _navigationAdapterRef4;
    return /*#__PURE__*/React__default.createElement(AgGridReact, {
      onRowClicked: props.onRowClicked,
      enableCellTextSelection: props.enableCellTextSelection,
      ensureDomOrder: props.enableCellTextSelection,
      onSortChanged: function onSortChanged(ev) {
        sortChangedRef.current = true;
        var sortModel = gridApi.current.sortController.getSortModel();
        props.onSortChanged(sortModel);
        fetchData();
        props.onSortChanged(ev);
      },
      unSortIcon: true,
      rowDragManaged: props.rowDragManaged,
      suppressMoveWhenRowDragging: props.suppressMoveWhenRowDragging,
      onRowDragEnter: function onRowDragEnter(params) {
        setIsDragging(true);
        props.onRowDragEnter(params);
      },
      getRowId: props.getRowId ? props.getRowId : undefined,
      onRowDragEnd: function onRowDragEnd(params) {
        if (isDraggingData.current) {
          setData(isDraggingData.current);
          isDraggingData.current = null;
        }
        setIsDragging(false);
        props.onRowDragEnd(params);
      },
      onRowDragMove: function onRowDragMove(params) {
        if (!props.rowDragManaged && props.rowLevelDragHandle && !props.rowDragEntireRow) {
          _onRowDragMove(params);
          props.onRowDragMove(params);
        }
      },
      rowDragEntireRow: props.rowDragEntireRow,
      rowDragMultiRow: props.rowDragMultiRow,
      icons: {
        sortUnSort: function sortUnSort() {
          return "".concat(ReactDOMServer.renderToStaticMarkup(/*#__PURE__*/React__default.createElement(IlIcon, {
            name: "gs-arrows-up&downfill"
          })).toString());
        },
        rowDrag: function rowDrag() {
          return "".concat(ReactDOMServer.renderToStaticMarkup(/*#__PURE__*/React__default.createElement(IlIcon, {
            name: "gs-reorderrow",
            size: 16
          })).toString());
        },
        sortDescending: function sortDescending() {
          return "".concat(ReactDOMServer.renderToStaticMarkup(/*#__PURE__*/React__default.createElement(IlIcon, {
            name: "gs-arrows-downfill"
          })).toString());
        },
        sortAscending: function sortAscending() {
          return "".concat(ReactDOMServer.renderToStaticMarkup(/*#__PURE__*/React__default.createElement(IlIcon, {
            name: "gs-arrows-upfill"
          })).toString());
        }
      },
      rowDragText: props.rowDragText,
      onColumnResized: function onColumnResized(ev) {
        if (ev.finished) {
          var settingsByField = {};
          var newSettings = {};
          columnSettings.current.forEach(function (columnSetting) {
            settingsByField[columnSetting.field] = columnSetting;
          });
          ev.columns.forEach(function (column) {
            newSettings[column.getColId()] = {
              field: column.getColId(),
              width: column.getActualWidth()
            };
          });

          // Resetting column settings and recreating them;
          columnSettings.current = [];
          Object.keys(settingsByField).forEach(function (key) {
            if (newSettings[key]) {
              Object.assign(settingsByField[key], newSettings[key]);
            }
            columnSettings.current.push(settingsByField[key]);
          });
          persistColumnSettings();
          props.onColumnResized(ev);
        }
      },
      suppressPaginationPanel: true,
      paginationPageSize: props.pageSize,
      pagination: props.paginationLoadMore ? false : props.pagination
      // suppressRowTransform={true}
      ,
      animateRows: true,
      isRowSelectable: props.isRowSelectable
      // suppressCellSelection
      ,
      suppressRowClickSelection: true,
      suppressDragLeaveHidesColumns: true,
      onPaginationChanged: function onPaginationChanged(ev) {
        props.onPaginationChanged(ev);
      },
      onColumnMoved: function onColumnMoved() {
        persistColumnSettings();
      },
      onDragStopped: function onDragStopped(params) {
        props.onDragStopped(params, columnSettings.current);
      },
      onCellClicked: function onCellClicked(params) {
        props.onCellClicked(params);

        // If the row is selectable, we want to allow clicking on links
        // without selecting the row.  Common use-case.
        if (!props.suppressRowClickSelection) {
          if (props.selectable) {
            if (params.event.target.tagName.toUpperCase() !== 'A') {
              if (contextMenuVisible) {
                setContextMenuVisible(false);
              } else {
                params.node.setSelected(!params.node.isSelected());
              }
            }
          }
        }
      },
      onGridReady: function onGridReady(params) {
        if (props.sizeColumnsToFit) {
          params.api.sizeColumnsToFit();
        }
        if (props.dropZoneId || props.getDropZoneContainer) {
          params.api.addRowDropZone({
            getContainer: function getContainer() {
              if (props.getDropZoneContainer) {
                return props.getDropZoneContainer();
              } else {
                return document.getElementById(props.dropZoneId);
              }
            },
            onDragging: function onDragging(params) {
              props.onDragging(params);
            },
            onDragEnter: function onDragEnter(params) {
              props.onDragEnter(params);
            },
            onDragLeave: function onDragLeave(params) {
              props.onDragLeave(params);
            },
            onDragStop: function onDragStop(params) {
              props.onDragStop(params);
            }
          });
        }
        gridApi.current = params.api;
        props.onGridReady(params, {
          forceFetchData: fetchData,
          resetPagination: function resetPagination() {
            setPage(0);
            pageRef.current = 0;
          }
        });
      },
      onFirstDataRendered: navigationAdapterRef === null || navigationAdapterRef === void 0 || (_navigationAdapterRef = navigationAdapterRef.current) === null || _navigationAdapterRef === void 0 ? void 0 : _navigationAdapterRef.initialize,
      onComponentStateChanged: navigationAdapterRef === null || navigationAdapterRef === void 0 || (_navigationAdapterRef2 = navigationAdapterRef.current) === null || _navigationAdapterRef2 === void 0 ? void 0 : _navigationAdapterRef2.update,
      onSelectionChanged: navigationAdapterRef === null || navigationAdapterRef === void 0 || (_navigationAdapterRef3 = navigationAdapterRef.current) === null || _navigationAdapterRef3 === void 0 ? void 0 : _navigationAdapterRef3.rowSelectionHandler,
      onViewportChanged: navigationAdapterRef === null || navigationAdapterRef === void 0 || (_navigationAdapterRef4 = navigationAdapterRef.current) === null || _navigationAdapterRef4 === void 0 ? void 0 : _navigationAdapterRef4.resetContentTabIndicesDebounced,
      tabToNextCell: function tabToNextCell() {
        return null;
      },
      onCellValueChanged: function onCellValueChanged(params) {
        props.onCellValueChanged(params);
      },
      rowData: data,
      defaultColDef: defaultColDef,
      rowSelection: 'multiple',
      columnDefs: getColumnDefs(),
      onRowSelected: function onRowSelected(params) {
        rowSelectionCallback(false, params);
      },
      rowHeight: props.rowHeight || 50,
      headerHeight: props.headerHeight,
      getRowHeight: props.getRowHeight,
      getRowClass: function getRowClass(params) {
        var _params$node, _props$highlightedRow;
        var rowClasses = [props.getRowClass(params)];
        if ((params === null || params === void 0 || (_params$node = params.node) === null || _params$node === void 0 ? void 0 : _params$node.rowIndex) === (props === null || props === void 0 || (_props$highlightedRow = props.highlightedRow) === null || _props$highlightedRow === void 0 ? void 0 : _props$highlightedRow.rowIndex)) {
          rowClasses.push('highlight-row');
        }
        if (props.highlightRow) {
          var highlightMode = props.highlightRow(params);
          if (highlightMode === 'warning') {
            rowClasses.push('IlDataTableV3-RowHighlight');
            rowClasses.push('IlDataTableV3-RowHighlight-Warning');
          } else if (highlightMode === 'primary' || highlightMode) {
            rowClasses.push('IlDataTableV3-RowHighlight');
            rowClasses.push('IlDataTableV3-RowHighlight-Primary');
          }
        }
        return rowClasses.join(' ');
      }
    });
  }
  function rowSelectionCallback(selectAll, params) {
    if (props.selectable) {
      if (!selectAll) {
        if (!currentlySelectingAll.current) {
          setSelectedRows(params.api.getSelectedRows());
          props.onRowSelected(params);
        }
      } else {
        currentlySelectingAll.current = true;
        gridApi.current.selectAll();
        setSelectedRows(gridApi.current.getSelectedRows());
        props.onRowSelectAll();

        // This is a really stupid fix... but I don't see a way to make the
        // difference between individual row selection and select/deselect all
        // in AgGrid.  Problem is that when you do a select all, it triggers
        // onRowSelected for every single row, and that gets really slow really
        // quickly.  So here we are.
        setTimeout(function () {
          currentlySelectingAll.current = false;
        }, 250);
      }
    }
  }
  if (props.expandableRows) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: 'IlDataTableV3'
    }, /*#__PURE__*/React__default.createElement(IlIconInitializer, null), _renderTitle(), /*#__PURE__*/React__default.createElement("div", {
      className: 'IlDataTableV3Header'
    }, _renderTertiaryToolbar(), _renderHeader(), _renderToolbar()), /*#__PURE__*/React__default.createElement(IlDataTableV3Expanding, _extends({}, props, {
      overlayNoRows: props.overlayNoRows,
      loading: loading,
      page: page,
      pageSize: pageSize,
      pageSizes: props.pageSizes,
      totalCount: totalCount,
      setPage: setPage,
      setPageSize: setPageSize,
      selectedIds: props.selectedIds,
      data: data,
      fetchData: props.fetchData ? fetchData : null,
      onGridReady: function onGridReady(api, v3Api) {
        gridApi.current = api;
        props.onGridReady(api, v3Api);
      }
    })));
  } else {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(IlIconInitializer, null), /*#__PURE__*/React__default.createElement("div", {
      className: ['IlDataTableV3', 'ag-theme-alpine', isDragging ? 'dragging' : null, props.dynamicHeight ? 'IlDataTableV3-DynamicHeight' : ''].join(' ')
    }, _renderTitle(), /*#__PURE__*/React__default.createElement("div", {
      className: 'IlDataTableV3Header'
    }, _renderBatchToolbar(), _renderTertiaryToolbar(), _renderHeader(), _renderToolbar()), /*#__PURE__*/React__default.createElement("div", {
      ref: gridDivRef,
      style: {
        flexGrow: 1,
        position: 'relative'
      }
    }, _renderNoRows(), _renderGrid()), _renderPagination()), contextMenuVisible && /*#__PURE__*/React__default.createElement(IlDataTableV3ContextMenu, {
      offset: -10,
      x: contextMenuX,
      y: contextMenuY,
      gridApi: gridApi.current,
      items: contextMenuItems,
      data: contextMenuData,
      onHide: function onHide() {
        setContextMenuVisible(false);
      },
      onShow: function onShow() {
        setContextMenuVisible(true);
      }
    }));
  }
}
IlDataTableV3.propTypes = {
  id: PropTypes.any,
  sortable: PropTypes.bool,
  pagination: PropTypes.bool,
  resizable: PropTypes.bool,
  selectable: PropTypes.bool,
  searchable: PropTypes.bool,
  columnManager: PropTypes.bool,
  rowDragManaged: PropTypes.bool,
  isRowSelectable: PropTypes.func,
  suppressRowClickSelection: PropTypes.bool,
  onSearch: PropTypes.func,
  onSortChanged: PropTypes.func,
  onColumnResized: PropTypes.func,
  onCellClicked: PropTypes.func,
  onRowSelected: PropTypes.func,
  onPaginationChanged: PropTypes.func,
  onCellValueChanged: PropTypes.func,
  contextMenuItems: PropTypes.array,
  batchActionsToolbarVisibleItems: PropTypes.number,
  batchActionsToolbarItems: PropTypes.array,
  cancelButtonText: PropTypes.string,
  setSingleItemSelectedTranslation: PropTypes.func,
  setMultipleItemsSelectedTranslation: PropTypes.func,
  page: PropTypes.number,
  pageSize: PropTypes.number,
  pageSizes: PropTypes.object,
  persistColumnSettingsInLocalStorage: PropTypes.bool,
  columnSettings: PropTypes.array,
  columns: PropTypes.array,
  data: PropTypes.array,
  fetchData: PropTypes.func,
  title: PropTypes.string || PropTypes.element,
  description: PropTypes.string || PropTypes.element,
  onPaginationChange: PropTypes.func,
  suppressHideSearchOnSelection: PropTypes.bool,
  onRowClicked: PropTypes.func,
  enableCellTextSelection: PropTypes.bool
};
IlDataTableV3.defaultProps = {
  sortable: false,
  pagination: false,
  resizable: false,
  selectable: true,
  searchable: true,
  columnManager: false,
  rowDragManaged: false,
  rowLevelDragHandle: false,
  suppressRowClickSelection: true,
  batchActionsToolbarVisibleItems: 3,
  batchActionsToolbarItems: [],
  cancelButtonText: undefined,
  setSingleItemSelectedTranslation: undefined,
  setMultipleItemsSelectedTranslation: undefined,
  onSearch: function onSearch() {},
  onSortChanged: function onSortChanged() {},
  onColumnResized: function onColumnResized() {},
  onCellClicked: function onCellClicked() {},
  onRowSelected: function onRowSelected() {},
  onPaginationChange: function onPaginationChange() {},
  onCellValueChanged: function onCellValueChanged() {},
  onPaginationChanged: function onPaginationChanged() {},
  onRowSelectAll: function onRowSelectAll() {},
  onRowDeselectAll: function onRowDeselectAll() {},
  contextMenuItems: [],
  searchDebounceTime: 500,
  suppressAutoSearch: false,
  searchMinimumLength: 3,
  page: 0,
  pageSize: 20,
  pageSizes: DTV3_PAGINATION_DEFAULT_PAGE_SIZES,
  persistColumnSettingsInLocalStorage: false,
  columnSettings: [],
  columns: [],
  data: [],
  suppressHideSearchOnSelection: false,
  onGridReady: function onGridReady() {},
  onDragging: function onDragging() {},
  onDragEnter: function onDragEnter() {},
  onDragLeave: function onDragLeave() {},
  onDragStop: function onDragStop() {},
  onRowDragEnter: function onRowDragEnter(params) {},
  onRowDragEnd: function onRowDragEnd(params) {},
  onRowDragMove: function onRowDragMove(params) {},
  getRowClass: function getRowClass(params) {},
  suppressMoveWhenRowDragging: false,
  getColumnsSettings: function getColumnsSettings(params) {},
  onColumnManagerClose: function onColumnManagerClose(params) {},
  onDragStopped: function onDragStopped(params, columnSettings) {},
  columnManagerNonceId: '',
  onRowClicked: function onRowClicked() {},
  paginationLoadMoreText: 'Load More',
  paginationLoadMoreForceSkeleton: false,
  stickyHeader: false,
  stickyHeaderOffset: 0,
  dynamicHeight: false,
  enableCellTextSelection: false
};

export { IlDataTableV3 as default };
